/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The frozen remote identity of a dormant (unlinked-but-preserved) job link
 * (spec §1). Surfaced so the frontend can show a "was linked to <ATS>" banner
 * and offer re-link/resume.
 */
export interface DormantLinkView {
  reason: string;
  connector_name: string;
  connection_id: string;
  remote_job_id: string;
  remote_job_name?: string | null;
}
